import React, { useState, useEffect } from 'react';
import { loadable } from '@Components/Utilities/SandhillsLoadable';
import { SandhillsSlickSlider } from '@Components/Shared/SandhillsSlickSlider';
import EmbeddedYouTubeVideoThumbnail from '@Components/Shared/EmbeddedYouTubeVideoThumbnail';
import SimpleHomeBreadcrumb from '@Components/Shared/SimpleHomeBreadcrumb';
import { useWindowSize } from '@Components/Utilities/WindowSize';
import { gtmPushEvent } from '@Components/Utilities/SandhillsUtility';
import { gtmEventType} from '@Components/Utilities/SandhillsConstants';

const RetirementAuctionsView = (props) => {
    const windowSize = useWindowSize();

    return (
        <div className="retirement-auctions-container">
            <SimpleHomeBreadcrumb homeRoute={props.BreadCrumbHomeRoute} displayText={props.BreadCrumbText} />
            <div className='container'>
                <div className="video-section">
                    <div className="section-text">
                        <h2>{props.H1Header}</h2>
                        <div className="section-subheading" dangerouslySetInnerHTML={{ __html: props.PageSubheader }} />
                        <div dangerouslySetInnerHTML={{ __html: props.RetirementAuctionsIntroText }} />
                        <a className="ts-button phone" href="tel:+14024584570" onClick={() => gtmPushEvent(gtmEventType.call)}><i className='fas fa-phone' />&nbsp;{props.CallButtonText}</a>
                    </div>
                    <div className="retirement-auctions-video">
                        <EmbeddedYouTubeVideoThumbnail
                            descriptionText={props.HeroVideoCaption}
                            altText={props.HeroVideoCaption}
                            videoId={props.HeroVideoID}
                            onOpen={() => gtmPushEvent(gtmEventType.youtube_thumbnail, 'videoName', "Retirement-Auctions-Hero")}
                        />
                    </div>
                </div>
            </div>
            <div className='container' style={{ 'backgroundColor': '#f6f6f6' }}>
                <div className="step-section">
                    <h2 className="section-heading">{props.StepSectionTitle}</h2>
                    <div className="step-row">
                        <div className="step">
                            <h3>Step 1</h3>
                            <strong className="step-title">{props.StepOneTitle}</strong>
                            <p>{props.StepOneText}</p>
                            <a href={props.RetirementAuctionLinks["LocalAuctioneer"]} target="_blank"><strong>{props.LocalAuctioneerLinkText}<i className='fa-solid fa-up-right-from-square' /></strong></a>
                        </div>
                        <div className="step">
                            <h3>Step 2</h3>
                            <strong className="step-title">{props.StepTwoTitle}</strong>
                            <div dangerouslySetInnerHTML={{ __html: props.StepTwoText }} />
                        </div>
                        <div className="step">
                            <h3>Step 3</h3>
                            <strong className="step-title">{props.StepThreeTitle}</strong>
                            <p>{props.StepThreeText}</p>
                            <a href={props.RetirementAuctionLinks["HowTo"]} target="_blank"><strong>{props.StepThreeLinkText}<i className='fa-solid fa-up-right-from-square' /></strong></a>
                        </div>
                        <div className="step">
                            <h3>Step 4</h3>
                            <strong className="step-title">{props.StepFourTitle}</strong>
                            <p>{props.StepFourText}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className='container'>
                <div className="image-section">
                    {!windowSize.isMobile &&
                        <div className="section-image">
                            <img src={props.WhySectionImageURL} alt="Website Platform Image" />
                        </div>
                    }
                    <div className="section-text checkmark-list">
                        <h2>{props.WhyAuctionTimeHeader}</h2>
                        <strong className="section-subheading">{props.WhyAuctionTimeSubheader}</strong>
                        <p>{props.WhyAuctionTimeCaption}</p>
                        <div className="bullets" dangerouslySetInnerHTML={{ __html: props.WhyAuctionTimeBenefits }} />
                    </div>
                    {windowSize.isMobile &&
                        <div className="section-image">
                            <img src={props.WhySectionImageURL} alt="Website Platform Image" />
                        </div>
                    }
                </div>
            </div>
            <div className='container' style={{ 'backgroundColor': '#f6f6f6' }}>
                <div className="image-section">
                    <div className="section-text">
                        <h2>{props.PlanningYourAuctionHeader}</h2>
                        <p>{props.PlanningYourAuctionCaption}</p>
                        <div className="bullets" dangerouslySetInnerHTML={{ __html: props.PlanningYourAuctionResources }} />
                    </div>
                    <div className="section-image">
                        <img src={props.PlanSectionImageURL} alt="Website Platform Image" />
                    </div>
                </div>
            </div>
            <div className='container'>
                <div className="double-video-section">
                    <div className="retirement-auctions-video">
                        <EmbeddedYouTubeVideoThumbnail
                            descriptionText={props.WhatSellersThinkATCaption}
                            altText={props.WhatSellersThinkATCaption}
                            videoId={props.WhatSellersThinkATVideoID}
                            onOpen={() => gtmPushEvent(gtmEventType.youtube_thumbnail, 'videoName', "What-Sellers-Say-AuctionTime")}
                        />
                    </div>
                    <div className="retirement-auctions-video">
                        <EmbeddedYouTubeVideoThumbnail
                            descriptionText={props.WhatSellersThinkPreATCaption}
                            altText={props.WhatSellersThinkPreATCaption}
                            videoId={props.WhatSellersThinkPreATVideoID}
                            onOpen={() => gtmPushEvent(gtmEventType.youtube_thumbnail, 'videoName', "What-Sellers-Say-PreAuctionTime")}
                        />
                    </div>
                </div>
            </div>
            <div className='container' style={{ 'backgroundColor': '#f6f6f6' }}>
                <div className="image-section at-section">
                    {windowSize.isMobile &&
                        <div className="section-image">
                            <img src={props.AuctionTimeLogoURL} alt="Website Platform Image" />
                        </div>
                    }
                    <div className="section-text">
                        <h2>{props.ReadyToPlanHeader}</h2>
                        <div dangerouslySetInnerHTML={{ __html: props.ReadyToPlanText }} />
                        <a className="ts-button" href={props.RetirementAuctionLinks["LocalAuctioneer"]} target="_blank">{props.LocalAuctioneerLinkText}</a>
                        <a className="ts-button" href={props.RetirementAuctionLinks["ContactAuctionTime"]} target="_blank">{props.ContactAuctionTimeLinkText}</a>
                    </div>
                    {!windowSize.isMobile &&
                        <div className="section-image at-image">
                            <img src={props.AuctionTimeLogoURL} alt="Website Platform Image" />
                        </div>
                    }
                </div>
            </div>
            <div className='vip-container'>
                <div className="vip-section">
                    <div className="vip-content">
                        <h2>{props.VIPHeader}</h2>
                        <div className="button-container">
                            <a className="ts-button" href={props.RetirementAuctionLinks["FreeEstimate"]} target="_blank">{props.FreeEstimateLinkText}</a>
                            <a className="ts-button" href={props.RetirementAuctionLinks["ViewEquipmentResults"]} target="_blank">{props.ViewResultsLinkText}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}

export default RetirementAuctionsView;
global.RetirementAuctionsView = RetirementAuctionsView;